"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialiseTrackers = void 0;
var utils_1 = require("../../utils");
function initialiseTrackers(trackers, setTrackersReady) {
    var trackerInitResults = trackers.map(function (_a) {
        var init = _a.init;
        return (init ? init() : null);
    });
    // If none of the results are promises then we can say the trackers
    // are immediately ready
    if (trackerInitResults.every(function (result) { return !(0, utils_1.isPromise)(result); })) {
        setTrackersReady(true);
    }
    else {
        Promise.all(
        // Force promises to resolve in case they error
        trackerInitResults.map(function (result) { return Promise.resolve(result); })).then(function () {
            setTrackersReady(true);
        });
    }
}
exports.initialiseTrackers = initialiseTrackers;
